import { IUpdateFolhaPagamentoUseCase } from "../../../presentation/useCases/update/update_folha_pagamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateFolhaPagamentoUseCase
 */

export class UpdateFolhaPagamentoUseCase implements IUpdateFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async updateFolhaPagamento(
    idFolhaPagamento: number,
    dataCadastro: Date,
    dataPagamento: Date,
    descricao: string,
    tipo: number,
  ): Promise<void> {
    await this.repository.updateFolhaPagamento(
      idFolhaPagamento,
      dataCadastro,
      dataPagamento,
      descricao,
      tipo,
    );
  }
}
